/**
 * Renders profile or team stats modal when opened via StatsModalContext. No redirect.
 */

import React from 'react';
import { useStatsModal } from '../contexts/StatsModalContext';
import ProfileStatsModal from './ProfileStatsModal';
import TeamStatsModal from './TeamStatsModal';

export default function StatsModalRenderer() {
  const { profileUserId, teamPlayerIds } = useStatsModal();
  if (profileUserId) return <ProfileStatsModal />;
  if (teamPlayerIds && teamPlayerIds.length > 0) return <TeamStatsModal />;
  return null;
}
